import {
  HISTORY_SMOKING_DYING_FAILED,
  HISTORY_SMOKING_DYING_REQUEST,
  HISTORY_SMOKING_DYING_SUCCESS,
} from "app/redux/actions/Factory/SmokingDying/history/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const historySmokingDyingReducer = function (
  state = INIT_STATE,
  action
) {
  switch (action?.type) {
    case HISTORY_SMOKING_DYING_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case HISTORY_SMOKING_DYING_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case HISTORY_SMOKING_DYING_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
